import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetNotesBySourceQuery, useGetNoteVendorLeadTaskBySourceQuery } from "store/services/noteApi";
import { useVendorLeadDetailContext } from "contexts/VendorLeadContext";
import CommentTab from "../../Note/Notetab";
import VendorLeadOnboardingTab from "./VendorLeadOnBoardingTab";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import VendorLeadStatusLogTab from "./VendorLeadStatusLogTab";
import VendorLeadStepLogTab from "./VendorLeadStepLogTab";
import VendorLeadQuotationPdfExcelTab from "./VendorLeadQuotationPdfExcelTab";
import VendorLeadTaskTab from "./VendorLeadTaskTab";

const VendorLeadDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "note";

  const { vendorLeadDetail } = useVendorLeadDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    { source: "VendorLead", sourceRef: vendorLeadDetail?._id },
    { skip: !vendorLeadDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "VendorLead", sourceRef: vendorLeadDetail?._id },
    { skip: !vendorLeadDetail?._id }
  );

  const { data: tasks } = useGetNoteVendorLeadTaskBySourceQuery(
    { sourceRef: vendorLeadDetail?._id },
    { skip: !vendorLeadDetail?._id }
  );

  const statusLogCount = vendorLeadDetail?.statusLog?.length || 0;
  const stepLogCount = vendorLeadDetail?.stepLog?.length || 0;
  const vendorQuotationCount = vendorLeadDetail?.vendorQuotationPdfExcel?.length || 0;

  const tabs = [
    { label: "Note", value: "note", badgeCount: notes?.length || 0 },
    { label: "Action Tasks", value: "tasks", badgeCount: tasks?.length || 0 },
    { label: "Steps", value: "onboarding" },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Status Log", value: "statusLog", badgeCount: statusLogCount },
    { label: "Step Log", value: "stepLog", badgeCount: stepLogCount },
    { label: "Quotation", value: "quotation", badgeCount: vendorQuotationCount },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {vendorLeadDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <CommentTab source="VendorLead" sourceRef={vendorLeadDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="tasks">
            <VendorLeadTaskTab sourceRef={vendorLeadDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="onboarding">
            <VendorLeadOnboardingTab />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="VendorLead" sourceRef={vendorLeadDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="statusLog">
            <VendorLeadStatusLogTab />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="stepLog">
            <VendorLeadStepLogTab />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="quotation">
            <VendorLeadQuotationPdfExcelTab leadId={vendorLeadDetail._id} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default VendorLeadDetailTab;